export default __webpack_public_path__ + "static/media/sign-up-illustration.48ece2f5.svg";